import { Props as SimpleBarProps } from 'simplebar-react';

import { StyledSimpleBar } from './Layout.styled';

export type OverlayScrollerProps = {
  variant?: 'page' | 'section';
  height?: number;
} & SimpleBarProps;

export function OverlayScroller({
  variant = 'section',
  height,
  ...props
}: OverlayScrollerProps) {
  const getHeight = () => {
    if (variant === 'page') {
      return '100dvh';
    }
    if (variant === 'section') {
      return '100%';
    }
    return '100%';
  };
  const computedHeight = height || getHeight();
  return (
    <StyledSimpleBar
      style={{
        height: computedHeight,
      }}
      {...props}
    />
  );
}
